export const validateRequiredFields = (stateCopy, requiredFields) => {
  const validate = requiredFields.every(
    element => stateCopy[element].length > 0
  );
  return validate;
};

export const validateArrayFields = (stateCopy, requiredFields) => {
  return stateCopy.map(element =>
    element[requiredFields].every(elem => element[elem].length > 0)
  );
};
